<template>
  <div class="container-fluid medicine-check-print-print">
    <div class="v-clean p-5 text-center mt-5" v-if="prescriptions.length == 0">
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div
        v-if="prescriptions.length > 0"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right div-btn-print"
      >
        <v-btn @click="handlePrint" class="btn-print"
          ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
        >
      </div>
      <div v-if="prescriptions.length > 0">
        <table
          class="table-leaves table-sm bg-white"
          v-for="(leave, key) in leaves"
          :key="key"
          cellpadding="0"
          cellspacing="0"
        >
          <div class="row">
            <div
              class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-12 pb-0 pt-1 text-center"
            >
              <img
                v-if="rest_home_logo_url"
                class="rest_home_logo_url"
                :src="rest_home_logo_url"
              />
              <div v-if="!rest_home_logo_url" class="ml-1">
                <strong class="text-uppercase">{{ rest_home_name }}</strong>
              </div>
            </div>
            <div class="col-xl-7 col-lg-7 col-md-7 col-sm-7 col-12 pb-0 pt-1">
              <div class="row">
                <img
                  v-if="resident.photo_url"
                  class="resident_photo_url"
                  :src="resident.photo_url"
                />
                <img
                  v-if="!resident.photo_url"
                  class="resident_photo_url"
                  :src="require('../../../../../assets/user.png')"
                />
                <ResidentDataPrintDefault :resident_id="resident_id" />
              </div>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12 text-center">
              <img class="logo" :src="logo" width="180" />
            </div>
          </div>

          <div class="content">
            <p v-if="resident.pathology" class="mt-2 m-0">
              <strong>Patologia (Doença):</strong>
              {{ resident.pathology }}
            </p>

            <p v-if="resident.miscellaneous_allergies" class="mb-2 m-0">
              <strong>Alergia Diversas:</strong>
              {{ resident.miscellaneous_allergies }}
            </p>
            <h6 class="title-one text-center">
              Prescrição Médica - Validade
              <span class="color-blue">{{
                formatDate(group_prescription_medicine.start_date, false)
              }}</span>
              até
              <span class="color-blue">{{
                formatDate(group_prescription_medicine.end_date, false)
              }}</span>
            </h6>
            <div class="text-center" v-if="userData().show_user_on_print == 1">
              Gerado por
              {{
                professionalClassCouncilValue({
                  id: user.professional_class_council_id,
                  name: user.name,
                  profile: user.profile_name,
                  cpf: user.cpf,
                  office: user.office,
                  value: user.professional_class_council_value,
                })
              }}
              <small> - {{ moment().format("DD/MM/YYYY HH:mm:ss") }} </small>
            </div>
            <table class="table-bordered" cellpadding="0" cellspacing="0">
              <th>MEDICAMENTO</th>
              <th class="text-center">HORÁRIO</th>
              <th
                v-for="item in leave"
                :key="item"
                v-show="item"
                class="text-center"
              >
                {{ formatDateDayMonth(item) }}
              </th>

              <tr
                v-for="(prescription, index) in prescriptions"
                :key="`${index}-${prescription.medicine.id}`"
                v-show="prescription.items.length > 0"
                class="tr-inf"
              >
                <td style="padding: 1px !important">
                  <h6 class="mb-0 text-thirteen">
                    {{ index + 1 }} -
                    <strong>{{ prescription.medicine.medicine_name }}</strong>
                  </h6>
                  <h6 class="text-thirteen worksansr mb-1">
                    {{ prescription.medicine.medicine_active_ingredient }}
                  </h6>
                  <h6 class="mb-0 worksansr text-thirteen">
                    VIA:
                    {{ prescription.medicine.route_of_administration_name }}
                  </h6>
                  <h6
                    class="mb-0 worksansr text-thirteen"
                    v-if="prescription.medicine.instruction"
                  >
                    {{ prescription.medicine.instruction }}
                  </h6>
                </td>
                <td style="padding: 1px !important">
                  <h6
                    class="mb-0 text-thirteen text-center"
                    v-if="!prescription.prescription_medicine_time.time"
                  >
                    <strong>EVENTUAL</strong>
                  </h6>
                  <h6
                    class="mb-0 text-thirteen text-center"
                    v-if="prescription.prescription_medicine_time.time"
                  >
                    {{
                      String(
                        prescription.prescription_medicine_time.time
                      ).substr(0, 5)
                    }}
                  </h6>
                </td>
                <td
                  v-for="item in prescription.items"
                  v-show="leave.includes(item.show_date)"
                  :key="item.show_date"
                  style="padding: 1px !important"
                >
                  <Daily
                    v-if="
                      item.status != 'NAO_MOSTRAR' &&
                      item.item.frequency == 'DIARIO'
                    "
                    :item="item"
                  />
                  <Weekly
                    v-if="
                      item.status != 'NAO_MOSTRAR' &&
                      item.item.frequency == 'SEMANAL'
                    "
                    :item="item"
                  />
                  <Monthly
                    v-if="
                      item.status != 'NAO_MOSTRAR' &&
                      item.item.frequency == 'MENSAL'
                    "
                    :item="item"
                  />
                  <Yearly
                    v-if="
                      item.status != 'NAO_MOSTRAR' &&
                      item.item.frequency == 'ANUAL'
                    "
                    :item="item"
                  />
                  <Eventual
                    v-if="item.item.frequency == 'EVENTUAL'"
                    :item="item"
                  />
                  <div class="text-center" v-if="item.check_anticipated == 1">
                    <i class="fas fa-clock icon-check-anticipated"></i>
                  </div>
                </td>
              </tr>
            </table>
          </div>
        </table>
      </div>
      <div
        v-if="prescriptions.length > 0"
        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right div-btn-print"
      >
        <v-btn @click="handlePrint" class="btn-print"
          ><i class="fas fa-print mr-2 text-twenty"></i>IMPRIMIR</v-btn
        >
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ResidentDataPrintDefault from "../../../../../components/resident/ResidentDataPrintDefault";

import Daily from "../../Prescription/View/Daily";

import Eventual from "../../Prescription/View/Eventual";

import Monthly from "../../Prescription/View/Monthly";

import Weekly from "../../Prescription/View/Weekly";

import Yearly from "../../Prescription/View/Yearly";

import api from "../../../../../services/api";

import routes from "../../../../../routes";

import { userData, getStatic } from "../../../../../lib/functions";

import { getAge } from "../../../../../lib/getAgeByDate";

import {
  formatDate,
  categoryCoren,
  onlyCategoryCoren,
  formatDateDayMonth,
  formatDateOnlyNumbers,
  formatTimeOnlyNumbers,
  professionalClassCouncilValue,
} from "../../../../../lib/format";

import moment from "moment";

import { showUserOnPrint } from "../../../../../lib/show-user-on-print";

export default {
  name: "Prescription",
  components: {
    ResidentDataPrintDefault,
    Daily,
    Eventual,
    Monthly,
    Weekly,
    Yearly,
  },
  data() {
    return {
      order_by: "",
      frequency: "",
      rest_home_id: "",
      resident_id: "",
      date: "",
      end_date: "",
      leaves: [],
      days: [],
      user: {},
      resident: {},
      rest_home_name: "",
      rest_home_logo_url: "",
      group_prescription_medicine: {},
      prescriptions: [],
      errors: [],
      logo: "",
      type: "NORMAL",
      loading: false,
    };
  },
  created() {
    this.retrieve();
  },
  methods: {
    getAge,
    moment,
    formatDate,
    categoryCoren,
    onlyCategoryCoren,
    formatDateDayMonth,
    formatDateOnlyNumbers,
    formatTimeOnlyNumbers,
    professionalClassCouncilValue,
    userData,
    async retrieve() {
      let { rest_home_id, user, logo } = userData();

      this.rest_home_id = rest_home_id;

      this.user = user;
      this.rest_home_name = user.rest_home_name;
      this.rest_home_logo_url = user.logo_url;
      this.logo = logo;

      let { show_user_on_print } = userData();
      if (show_user_on_print != 1) {
        await showUserOnPrint({
          about: "Rotina diária prescrição de medicamento",
        });
      }

      const { resident_id, date, end_date, order_by, frequency } =
        routes.history.current.params;

      this.resident_id = resident_id;
      this.date = date;
      this.end_date = end_date;
      this.order_by = order_by;
      this.frequency = frequency;

      let accessed_offline = JSON.parse(
        sessionStorage.getItem("accessed_offline") || !this.$store.state.online
      );

      if (accessed_offline) {
        let residents;
        try {
          residents = (
            await getStatic("/offline/residents/prescriptions-normal", true)
          ).residents;
        } catch (errors) {
          this.errors = errors;
          return;
        }

        let resident = residents.filter((item) => item.id == resident_id);

        if (resident[0]) {
          if (resident[0].prescriptionNormal) {
            let {
              prescriptionNormal: {
                days,
                prescriptions,
                group_prescription_medicine,
                rest_home,
              },
            } = resident[0];

            this.rest_home = rest_home;
            this.resident = resident[0].prescriptionNormal.resident;

            this.days = days ? days : [];
            this.prescriptions = prescriptions ? prescriptions : [];
            this.group_prescription_medicine = group_prescription_medicine
              ? group_prescription_medicine
              : {};
          }
        }

        this.loading = false;
      } else {
        await this.get();
      }
    },
    async get() {
      try {
        this.loading = true;
        this.errors = [];

        const {
          rest_home_id,
          resident_id,
          date,
          end_date,
          order_by,
          frequency,
        } = this;

        let params = {
          rest_home_id,
          resident_id,
          date,
          end_date,
          order_by,
          frequency,
        };

        const response = await api.get(
          "/rest-home/resident/medicine-check-print",
          {
            params,
          }
        );

        const {
          error,
          errors,
          prescriptions,
          days,
          resident,
          rest_home,
          group_prescription_medicine,
        } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.prescriptions = prescriptions;
          this.days = days;
          this.resident = resident;
          this.rest_home = rest_home;
          this.group_prescription_medicine = group_prescription_medicine;

          this.leaves = this.separate(days, 15);
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },
    separate(base, max) {
      let result = [[]];
      let group = 0;

      for (let indice = 0; indice < base.length; indice++) {
        if (result[group] === undefined) {
          result[group] = [];
        }

        result[group].push(base[indice]);

        if ((indice + 1) % max === 0) {
          group = group + 1;
        }
      }

      return result;
    },
    professionalClassCouncil({ id = null, name = "", cpf = "", value = "" }) {
      const TYPE_COREN = 1;
      const TYPE_CRM = 2;

      name = String(name).split(" ");
      name = name[0];

      if (id == TYPE_COREN) {
        let category = categoryCoren(onlyCategoryCoren(value));
        value = String(value).substr(9);
        value = String(value).substr(0, value.length - 3);

        return [
          { position: 1, text: name },
          { position: 2, text: value },
          { position: 3, text: category },
        ];
      }

      if (id == TYPE_CRM) {
        return [
          { position: 1, text: name },
          { position: 2, text: value },
        ];
      }

      return [
        { position: 1, text: name },
        { position: 2, text: cpf },
      ];
    },
    handleColorUser(time) {
      if (
        parseInt(formatTimeOnlyNumbers(time)) >= parseInt(70000) &&
        parseInt(formatTimeOnlyNumbers(time)) < parseInt(190000)
      ) {
        return "c-primary";
      }

      if (parseInt(formatTimeOnlyNumbers(time)) >= parseInt(190000)) {
        return "c-danger";
      }
    },
    handlePrint() {
      window.print();
    },
  },
};
</script>

<style>
@media print and (-webkit-min-device-pixel-ratio: 0) {
  .medicine-check-print-print .user-name-checked {
    -webkit-print-color-adjust: exact !important;
  }
}

.medicine-check-print-print .header,
.medicine-check-print-print .header-space {
  height: 100px;
}
.medicine-check-print-print .header {
  position: fixed;
  top: 0;
}
.medicine-check-print-print .name {
  font-weight: bold;
}
.medicine-check-print-print .active-ingredient {
  font-size: 12px;
}
.medicine-check-print-print .via {
  font-weight: bold;
  font-size: 12px;
}
.medicine-check-print-print .user {
  width: 20px;
}
.medicine-check-print-print .checked-icon {
  width: 15px;
}
.medicine-check-print-print .logo {
  height: 50px;
  object-fit: contain;
}
.medicine-check-print-print .rest_home_logo_url {
  height: 80px;
  width: 100%;
  object-fit: contain;
}
.medicine-check-print-print .resident_photo_url {
  height: 80px;
  width: 80px;
  border-radius: 50% !important;
  object-fit: cover;
}

.medicine-check-print-print table,
.medicine-check-print-print td,
.medicine-check-print-print th,
.medicine-check-print-print tfoot {
  width: 100% !important;
  padding: 5px;
  cursor: auto !important;
}

@media print {
  @page {
    size: landscape;
    /* size: 21cm 29.7cm; */
    margin: 0cm 0cm 0cm 0cm;
  }
  .medicine-check-print-print .header {
    width: 100% !important;
    position: fixed;
    top: 0;
  }
  .medicine-check-print-print .header,
  .medicine-check-print-print .header-space {
    height: 150px;
  }
  .medicine-check-print-print button,
  .medicine-check-print-print .div-btn-print {
    display: none !important;
  }
  .medicine-check-print-print .table-leaves {
    page-break-after: always !important;
  }
  * {
    box-sizing: border-box !important;
  }
}
</style>
